import React from 'react';
import { CmsAsset } from '../../integrations/contentful/types';
import { MediaItemWrapper } from '../cms/CmsMediaCarousel';
import { baseXInPixels, baseXUnit } from '../../styles/theme';
import CmsMedia from '../cms/CmsMedia';
import Icon from '../common/Icon';

interface MediaThumbnailProps {
  media: CmsAsset;
  onMediaClick?: (media: CmsAsset) => void;
  showMoreOverlay?: boolean;
}

const MediaThumbnail: React.FunctionComponent<MediaThumbnailProps> = ({
  media,
  onMediaClick,
  showMoreOverlay
}) => {
  return (
    <div className="media-thumbnail" data-testid="media-thumbnail">
      <MediaItemWrapper media={media} onMediaClick={onMediaClick}>
        <CmsMedia
          media={media}
          height={baseXInPixels(22)}
          width={baseXInPixels(24)}
          crop
          borderRadius={1}
          hover
        />
      </MediaItemWrapper>
      {showMoreOverlay && (
        <div className="show-more-overlay" data-testid="show-more-overlay">
          <div className="show-more-icon">
            <Icon name="nav-falafel" size={5} />
          </div>
        </div>
      )}
      {/*language=CSS*/}
      <style jsx>{`
        .media-thumbnail {
          cursor: pointer;
          overflow: hidden;
          border-radius: ${baseXUnit(1)};
          position: relative;
        }
        .show-more-overlay {
          pointer-events: none;
          position: absolute;
          top: 0;
          height: 100%;
          width: 100%;
          border-radius: ${baseXUnit(1)};
          background-color: white;
          opacity: 0.75;
        }
        .show-more-icon {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translateX(-50%) translateY(-50%);
        }
      `}</style>
    </div>
  );
};

export default MediaThumbnail;
